import styled from 'styled-components'

export const SkeletonRoot = styled.div.attrs({})`
  display: flex;
  width: 100%;
  padding: 32px clamp(18px, 3vw, 40px) 56px;
  flex-direction: column;
  gap: 28px;
`

export const SkeletonHeader = styled.div.attrs({})`
  display: flex;
  padding-bottom: 28px;
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};
  flex-direction: column;
  gap: 12px;
`

export const SkeletonPlayer = styled.div.attrs({})`
  width: 100%;
  max-width: 1180px;
  aspect-ratio: 16 / 9;
`

export const SkeletonText = styled.div.attrs({})`
  display: flex;
  width: 100%;
  max-width: 860px;
  flex-direction: column;
  gap: 12px;
`
